import React from "react";
import { useI18n } from "../i18n";

const eur = (v) => `${Number(v || 0).toFixed(2)}€`;

// Bloc unique HT produits / HT livraison / TVA / Remise / TOTAL TTC (+ cadeau regroupement, + gain / dû côté vendeur)
export function OrderAmounts({ amounts: a, vendorView = false, compact = false }) {
  const { t } = useI18n();
  if (!a) return null;
  const Row = ({ label, value, testId, strong, muted }) => (
    <div className={`flex justify-between gap-3 py-0.5 ${strong ? "font-anton text-neon-green text-base border-t border-zinc-700 mt-1 pt-1.5" : muted ? "text-zinc-500" : "text-zinc-300"} ${compact ? "text-xs" : "text-sm"}`} data-testid={testId}>
      <span>{label}</span><span className="tabular-nums whitespace-nowrap">{value}</span>
    </div>
  );
  return (
    <div data-testid="order-amounts" className="w-full">
      <Row label={t("am.products_ht")} value={eur(a.produits_ht)} testId="am-products-ht" />
      <Row label={`${t("am.delivery_ht")}${a.livraison_ttc === 0 ? ` (${t("am.free")})` : ""}`} value={eur(a.livraison_ht)} testId="am-delivery-ht" />
      {a.club_ttc > 0 && <Row label={t("am.club_ht")} value={eur(a.club_ht)} testId="am-club-ht" />}
      <Row label={t("am.vat")} value={eur(a.tva_totale)} testId="am-vat" />
      {(a.remise_detail || []).map((d, i) => <Row key={i} label={`${t("am.discount")} — ${d.label}`} value={`− ${eur(d.amount)}`} testId="am-discount" />)}
      {!(a.remise_detail || []).length && a.remise > 0 && <Row label={t("am.discount")} value={`− ${eur(a.remise)}`} testId="am-discount" />}
      {a.cadeau && <Row label={`🎁 ${t("am.gift")} : ${a.cadeau.name} — ${t("am.offered")}`} value={eur(0)} testId="am-gift" muted />}
      {a.cadeau_promo && <Row label={a.cadeau_promo.label} value={eur(0)} testId="am-promo-gift" muted />}
      <Row label={t("am.total")} value={eur(a.total_ttc)} testId="am-total" strong />
      {vendorView && (
        <div className="flex flex-wrap gap-x-4 gap-y-0.5 text-xs mt-1.5 pt-1.5 border-t border-dashed border-zinc-800">
          <span className="text-neon-green font-bold" data-testid="am-gain">💰 {t("am.gain")} : {eur(a.conserve)} <span className="font-normal text-neon-green/70">({eur(a.gain_vendeur)} + {t("am.delivery_ht").toLowerCase()} {eur(a.livraison_ht)})</span></span>
          <span className="text-zinc-400" data-testid="am-due">↩ {t("am.due")} : {eur(a.du_stuff)}</span>
        </div>
      )}
    </div>
  );
}
